import { makeStyles } from '@mui/styles';

export const subAdmin = ['Operations', 'Customer Supports', 'Marketing', 'Accounts', 'Designer', 'Data Analyst', 'Human Resources HR']
export const AccessLevel = [
  {
    id: 1,
    level_name: 'ADMIN',
    level_access: 100
  },
  {
    id: 3,
    level_name: 'SUB ADMIN',
    level_access: 80
  },
  {
    id: 4,
    level_name: 'VIEW ALL (1000)',
    level_access: 1000
  },
  {
    id: 5,
    level_name: 'VIEW BANK ONLY (999)',
    level_access: 999
  }
]

export const AccessTeam = [
  {
    id: 1,
    level_name: 'Read/Write',
  },
  {
    id: 2,
    level_name: 'Read Only',
  }

]

export const GAME_MODE = [
  {
    value: 'Point Club',
    label: 'Point Club',
    _id: 1

  },
  {
    value: 'Pool Club',
    label: 'Pool Club',
    _id: 2

  },
  {
    value: 'Deals Club',
    label: 'Deals Club',
    _id: 3

  },
]

export const GAME_POOL_TYPE = [
  {
    value: 51,
    label: 51,
    _id: 51
  },
  {
    value: 101,
    label: 101,
    _id: 101
  },
  {
    value: 201,
    label: 201,
    _id: 201
  }

]

export const GAME_DEAL_TYPE = [
  {
    value: 1,
    label: 1,
    _id: 1
  },
  {
    value: 2,
    label: 2,
    _id: 2
  },
  {
    value: 3,
    label: 3,
    _id: 3
  },
  // {
  //   value: 6,
  //   label: 6,
  //   _id: 6
  // }

]

export const GAME_MODE_WITH_ALL = [{
  value: 'All',
  label: 'All',
  _id: 0
}, ...GAME_MODE];


export const ACCESS_LEVEL = {
  ADMIN: 100,
  SUB_ADMIN: 80,
  CASHIER: 50,
  VIEW_ALL: 1000,
  VIEW_BANK: 999,
}

export const EntryList = [
  {
    value: 'Select Entry',
    label: 'Select Entry',
  },
  {
    value: 'Paid',
    label: 'Paid',
  },
  {
    value: 'Free',
    label: 'Free',
  }
]
export const statusList = [
  {
    value: 'Select Status',
    label: 'Select Status',
    _id: 0
  },
  {
    value: 'Active',
    label: 'Active',
    _id: 1
  },
  {
    value: 'Inactive',
    label: 'Inactive',
    _id: 0
  }
]

export const statusList_2 = [
  {
    value: 1,
    label: 'Active',
    _id: 1
  },
  {
    value: 0,
    label: 'InActive',
    _id: 0
  }
]

export const yesNoList = [
  {
    value: 'yes',
    label: 'Yes',
    _id: 1
  },
  {
    value: 'no',
    label: 'No',
    _id: 0
  }
]
export const deviceType = [
  {
    value: 'Android',
    label: 'Android',
    _id: 1
  },
  {
    value: 'IOS',
    label: 'IOS',
    _id: 0
  }
]

export const bannerType = [
  {
    value: 'all',
    label: 'All',
    _id: -1
  },
  {
    value: 'none',
    label: 'None',
    _id: 0
  },
  {
    value: 'invite',
    label: 'Invite',
    _id: 1
  },
  {
    value: 'offer',
    label: 'Offer',
    _id: 2
  },
  {
    value: 'challenge',
    label: 'Challenge',
    _id: 3
  },
  {
    value: 'url',
    label: 'Url',
    _id: 4
  },
  {
    value: 'leaderboard',
    label: 'Leaderboard',
    _id: 5
  },
  {
    value: 'tournament',
    label: 'Tournament',
    _id: 6
  },
  {
    value: 'vip',
    label: 'vip',
    _id: 7
  }

]
export const webBannerType = [
  {
    value: 'all',
    label: 'All',
    _id: -1
  },
  {
    value: 'top',
    label: 'Top',
    _id: 0
  },
  {
    value: 'left',
    label: 'Left',
    _id: 1
  },
  {
    value: 'middle',
    label: 'Middle',
    _id: 2
  },
  {
    value: 'right',
    label: 'Right',
    _id: 3
  },
  {
    value: 'bottom',
    label: 'Bottom',
    _id: 4
  }
]

export const webPage = [
 
  {
    value: 'home',
    label: 'Home',
    _id: 1
  },
  {
    value: 'download',
    label: 'Download',
    _id: 2
  },
  {
    value: 'blog',
    label: 'Blog',
    _id: 3
  }
]

export const webLanguage = [
  {
    value: 'english/hindi',
    label: 'English/Hindi',
    _id: 0
  },
  {
    value: 'english',
    label: 'English',
    _id: 1
  },
  {
    value: 'hindi',
    label: 'Hindi',
    _id: 2

  },
]

export const bannerViewMode = [
  
  {
    value: 'desktop',
    label: 'Desktop',
    _id: 1
  },
  {
    value: 'mobile',
    label: 'Mobile',
    _id: 2

  },
]
export const AdsbannerType = [
  {
    value: 0,
    label: 'All',
    _id: 0
  },
  {
    value: 1,
    label: 1,
    _id: 1
  },
  {
    value: 2,
    label: 2,
    _id: 2
  },
  {
    value: 3,
    label: 3,
    _id: 3
  },
  {
    value: 4,
    label: 4,
    _id: 4
  },
  
]


export const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: '1px solid #ccc',
    }
  }
});


export const PREDICTION_TYPE_GST = {
  IN_PLAY: 4
}
export const defaultCurrency = 'INR';



export const transcationArrayType = [
  { value: 'All',               label: 'All',               _id: 0  },
  { value: 'DEPOSIT',           label: 'DEPOSIT',           _id: 1  },
  { value: 'WITHDRAW',          label: 'WITHDRAW',          _id: 2  },
  { value: 'CHIP_ISSUE',        label: 'CHIP ISSUE',        _id: 3  },
  { value: 'CHIP_CASHOUT',      label: 'CHIP CASHOUT',      _id: 4  },
  { value: 'CHIP_EXCHANGE',     label: 'CHIP EXCHANGE',     _id: 5  },
  { value: 'LOAN_WALLET',        label: 'LOAN WALLET',        _id: 15 },
  { value: 'LOAN_DISBURSE',     label: 'LOAN DISBURSE',     _id: 6  },
  { value: 'LOAN_REPAY',        label: 'LOAN REPAY',        _id: 7  },
  { value: 'RAKE',              label: 'RAKE',              _id: 8  },
  { value: 'REFERRAL_CASHBACK', label: 'REFERRAL CASHBACK', _id: 9  },
  { value: 'EXPENSE',           label: 'EXPENSE',           _id: 10 },
  { value: 'BONUS_HOLDBACK',   label: 'BONUS HOLDBACK',    _id: 11 },
  { value: 'PROMO_CREDIT',     label: 'PROMO CREDIT',      _id: 12 },
  { value: 'DEPOSIT_CREDIT',   label: 'DEPOSIT CREDIT',    _id: 13 },
  { value: 'WINNING_CREDIT',   label: 'WINNING CREDIT',    _id: 14 },
];

export const transcationMode = [
  { value: 'All',   label: 'All',   _id: 0 },
  { value: 'BANK',  label: 'BANK',  _id: 1 },
  { value: 'CASH',  label: 'CASH',  _id: 2 },
  { value: 'OTHER', label: 'OTHER', _id: 3 },
];

export const walletFilterOptions = [
  { value: 'All',                  label: 'All',                  _id: 0 },
  { value: 'cash_deposite',        label: 'Cash Deposit',         _id: 1 },
  { value: 'winning_balance',      label: 'Winning Balance',      _id: 2 },
  { value: 'promotional_balance',  label: 'Promotional Balance',  _id: 3 },
  { value: 'loan_amount',          label: 'Loan Amount',          _id: 4 },
  { value: 'loan_distributed',     label: 'Loan Distributed',     _id: 5 },
];

export const gameTranscationArrayType = [
  { value: 'All', label: 'All', _id: 0 },
  { value: 'JOIN_CONTEST', label: 'JOIN CONTEST', _id: 3 },
  { value: 'WON_CONTEST', label: 'WON CONTEST', _id: 4 },
  { value: 'REFUND', label: 'REFUND', _id: 6 },
  { value: 'REFUND_FROM_Club_CONTEST', label: 'REFUND FROM Club CONTEST', _id: 50 },


];
export const withdrawStatus = [
  { value: 'Pending Manual', id: 0 },
  { value: 'Confirm', id: 1 },
  { value: 'Reject', id: 2 },
  { value: 'Pending Razorpay', id: 3 },
  { value: 'Razorpay Issue', id: 4 },
];

export const accountVeriedType = [
  { label: "All", value: "All", _id: -1 },
  { label: "Pending", value: "not_verifed", _id: 1 },
  { label: "Verifed Only", value: "verifed", _id: 2 },

]
export const leaderboardTypeList = [
  { label: "Daily", value: "Daily", _id: 1, title: "Day" },
  { label: "Weekly", value: "Weekly", _id: 2, title: "Week" },
  { label: "Monthly", value: "Monthly", _id: 3, title: "Month" },

]
export const winningType = [
  { label: "Gadget", value: "gadget", _id: 1 },
  { label: "Amount", value: "amount", _id: 2 },
]

export const bankChangeRequestType = [
  { label: "All", value: "All", _id: 0 },
  { label: "Yes", value: "Yes", _id: 1 },
  { label: "No", value: "No", _id: 2 },
]

export const walletType = [
  { label: "Cash Balance", value: "cash_balance" },
  { label: "Winning Balance", value: "winning_balance" },
  { label: "Bonus Balance", value: "bonus_amount" },
  { label: "Extra Balance", value: "extra_amount" },

]

export const websitePages = [
  { label: "Club Tournaments", value: "Club_tournaments" },
  { label: "Club Rules", value: "Club_rules" },
  { label: "Pool Club", value: "pool_Club" },
  { label: "Points Club", value: "points_Club" },
  { label: "Deals Club", value: "deals_Club" },
  { label: "Disclaimer", value: "disclaimer" },
  { label: "Refer & Earn", value: "refer_&_earn" },
  { label: "Safety & Security", value: "safety_&_security" },
  { label: "FAQs", value: "faqs" },
  { label: "Blogs", value: "blogs" },
  { label: "Legality", value: "legality" },
  { label: "Responsible Gaming", value: "responsible_gaming" },
  { label: "Reviews", value: "reviews" },
  { label: "About Us", value: "about_us" },
  { label: "Terms & Conditions", value: "terms_&_conditions" },
  { label: "Privacy Policy", value: "privacy_policy" },
  { label: "TDS Policy", value: "tds_policy" },
  { label: "GST Policy", value: "gst_policy" },
  { label: "Fair Play Policy", value: "fair_play_policy" },
  { label: "Club Offers", value: "Club_offers" },
  { label: "How to play", value: "how_to_play" },
  { label: "Blog", value: "blog" },
  { label: "Download page", value: "download_page" }
]

export const language = [
  { label: "English", value: "english" },
  { label: "Hindi", value: "hindi" },
]

export const CHALLENGE_TYPE = [
  {
    value: 'ALL',
    label: 'ALL',
    _id: 0
  },

  {
    value: 'GAME PLAY',
    label: 'GAME PLAY',
    _id: 1

  },
  {
    value: 'DEPOSIT',
    label: 'DEPOSIT',
    _id: 2
  },
]

export const USER_CATEGORY = [
  {
    value: 'LEVEL 1',
    label: 'LEVEL 1',
    _id: 1
  },
  {
    value: 'LEVEL 2',
    label: 'LEVEL 2',
    _id: 2
  },
  {
    value: 'LEVEL 3',
    label: 'LEVEL 3',
    _id: 3
  },
  {
    value: 'LEVEL 4',
    label: 'LEVEL 4',
    _id: 4
  },
  {
    value: 'LEVEL 5',
    label: 'LEVEL 5',
    _id: 5
  },
]

export const CHALLENGE_WALLET = [
  { label: "Cash Balance", value: "cash_balance", _id: 1 },
  { label: "Bonus Balance", value: "bonus_amount", _id: 2 },

]


export const COUPON_TYPE = [
  { label: "Bonus", value: "bonus", _id: 1 },
  { label: "Instant Cash Bonus", value: "extra", _id: 2 },
  { label: "Deposite", value: "extra_deposite", _id: 3 },

]

export const DEPOSITE_TYPE = [
  { label: "Debit Card", value: "debit_card", _id: 1 },
  { label: "Credit Card", value: "credit_card", _id: 2 },
  { label: "Paytm Wallet", value: "paytm_wallet", _id: 3 },
  { label: "Other Wallet", value: "other_wallet", _id: 4 },
  { label: "UPI", value: "upi", _id: 5 },
  { label: "Net-Banking All", value: "net_banking_all", _id: 6 },
  { label: "Net-Banking", value: "net_banking", _id: 7 },

]

export const USER_LEVEL = [
  { label: "Select Level", value: 0, _id: 0 },
  { label: "LEVEL 1", value: 1, _id: 1 },
  { label: "LEVEL 2", value: 2, _id: 2 },
  { label: "LEVEL 3", value: 3, _id: 3 },
  { label: "LEVEL 4", value: 4, _id: 4 },
  { label: "LEVEL 5", value: 5, _id: 5 },

]

export const CHALLENGE_ADD_TYPE = [

  {
    value: 1,
    label: 'GAME PLAY',
    _id: 1

  },
  {
    value: 2,
    label: 'DEPOSIT',
    _id: 2
  }
]
export const yesOrNo = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  }
]

export const DEPOSIT_TYPE = [
  {
    value: '',
    label: 'Select Payment Type',
  },
  {
    value: 'Card',
    label: 'Card',
  },
  {
    value: 'Recommendation',
    label: 'Recommendation',
  },
  {
    value: 'Wallet',
    label: 'Wallet',
  },
  {
    value: 'UPI/Google Pay/BHIM',
    label: 'Upi/Google Pay/BHIM',
  },
  {
    value: 'NETBANKING',
    label: 'NetBanking',
  }
]

export const PAYMENT_GATEWAY = [
  {
    value: '',
    label: 'Select Payment Gatway',
  },
  {
    value: 'WALLET',
    label: 'Wallet',
  },
  {
    value: 'Paytm',
    label: 'Paytm',
  },
  {
    value: 'ICICI',
    label: 'ICICI',
  },
  {
    value: 'CASH_FREE',
    label: 'Cash Free',
  },
  {
    value: 'PAYUBIZ',
    label: 'PayUbiz',
  },
  {
    value: 'PAYUMONEY',
    label: 'PayuMoney',
  },
  {
    value: 'PAYTM_ALL_IN_ONE',
    label: 'Paytm (PAYTM ALL IN ONE)',
  },
  {
    value: 'PHONEPE',
    label: 'PhonePe',
  },
  {
    value: 'MOBIKWIK',
    label: 'Mobikwik',
  },
  {
    value: 'PHONEPE_UPI',
    label: 'PhonePe UPI',
  },
  {
    value: 'PHONEPE_CARD',
    label: 'PhonePe Card',
  },

]

export const OPERATING_SYSTEM = [
  {
    value: 'a',
    label: 'Android',
  },
  {
    value: 'i',
    label: 'iPhone',
  },
  {
    value: 'b',
    label: 'Both Devices',
  },
]

export const CONTEST_SIZE = [
  {
    value: 2,
    label: 2,
    _id: 2

  },
  {
    value: 3,
    label: 3,
    _id: 3

  },
  {
    value: 4,
    label: 4,
    _id: 4

  },
  {
    value: 5,
    label: 5,
    _id: 5

  },
  {
    value: 6,
    label: 6,
    _id: 6
  },
]

export const INTERVEL_SIZE = [
  {
    value: 1,
    label: 1,
    _id: 1

  },
  {
    value: 2,
    label: 2,
    _id: 2

  },
  
]


//0=>pending/,1=>confirm,2=>reject request,
//status  (1 -> confirmed ), (4 -> failed, 0->> pending) , (2 - > reject) 
export const WITHDRAWAL_STATUS = [3, 4, 2, 1];
export const WITHDRAWAL_RANGE = [{MIN: '', MAX: ''},{MIN: '10000', MAX: ''}, {MIN: '5000', MAX: '10000'}, {MIN: '0', MAX: '5000'}];

export const YesNoOptions = [
  {
    value: 1,  
    label: 'Yes',
  },
  {
    value: 0,  
    label: 'No',
  }
]

export const LEADERBOARD_ALL = [{
  value: 'All',
  label: 'All',
  _id: 0
},
{
  value: 'Daily',
  label: 'Daily',
  _id: 1

},
{
  value: 'Weekly',
  label: 'Weekly',
  _id: 2

},
{
  value: 'Monthly',
  label: 'Monthly',
  _id: 3

}

];

export const DistributeType = [ 
{ label: "All", value: "All", _id: -1 },
{ label: "Yes", value: "Yes", _id: true },
{ label: "No", value: "No", _id: false },
];

export const statusType = [ { label: "All", value: "All", _id: -1 }, ...statusList_2];

export const WithdrawPhase = {
  "1": "150% to 300%",
  "2": "300% to 600%",
  "3": "600% to 1000%",
  "4": "1000% to 1500%",
  "5": "1500% to 2000%",
  "6": "2000% to 2500%",
  "7": "2500% to 3000%",
  "8": "3000% to 3500%",
  "9": "3500% to 4000%",
  "10": "4000% to 5000%",
  "11": "5000% to 6000%",
  "12": "6000% to 7000%",
  "13": "7000% to 8000%",
  "14": "8000% to 9000%",
  "15": "9000% to 10000%",
  "16": "10000% above",
}
export const WithdrawPhaseArray = Object.entries(WithdrawPhase).map(([key, value]) => ({
  label: value,
  value: key,
  _id: parseInt(key), // Convert key to a number
}));

export const youtuberBonusType = [
  {
    value: 1,
    label: 'join league percent ',
    _id: 1
  },
  {
    value: 2,
    label: 'revenue modal percent ',
    _id: 2
  }
]

export const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
  "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
  "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
  "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

export const FeedbackStatus = [
  {
    value: -1,
    label: 'Select Status',
    _id: -1
  },
  {
    value: true,
    label: 'Resolved',
    _id: 1
  },
  {
    value: false,
    label: 'Unresolved',
    _id: 0
  }
];

export const FeedbackEmailStatus = [
  {
    value: -1,
    label: 'Select Email Status',
    _id: 0
  },
  {
    value: true,
    label: 'Yes',
    _id: 1
  },
  {
    value: false,
    label: 'No',
    _id: 0
  }
];